import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { scrollToRef } from 'helpers/react-references.helper'
import { IMainState } from 'store/states'
import { BlockTypes } from 'enum/block-type.enum'
import Survey from './components/Survey/Index'
import styles from './BlockType.module.scss'
import RichText from './components/RichText/RichText'
import Task from './components/Task/Task'
import Multimedia from './components/Multimedia/Multimedia'
import Evaluation from './components/Evaluation'
import Scorm from './components/Scorm/Scorm'
import Meeting from './components/Meeting'

interface IBlockTypeButton {
  option: BlockTypes
  onCancel: () => void
  editing: boolean
}

const BlockTypeSelected = ({
  option,
  onCancel,
  editing,
  containerRef,
}: IBlockTypeButton & {
  containerRef: React.RefObject<HTMLDivElement>
}) => {
  const types = {
    [BlockTypes.BlockSurvey]: <Survey onCancel={onCancel} editing={editing} />,
    [BlockTypes.BlockRichText]: (
      <RichText onCancel={onCancel} editing={editing} />
    ),
    [BlockTypes.BlockTask]: <Task onCancel={onCancel} editing={editing} />,
    [BlockTypes.BlockMultimedia]: (
      <Multimedia onCancel={onCancel} editing={editing} />
    ),
    [BlockTypes.BlockEvaluation]: (
      <Evaluation
        onClose={onCancel}
        editing={editing}
        containerRef={containerRef}
      />
    ),
    [BlockTypes.BlockScorm]: <Scorm onCancel={onCancel} editing={editing} />,
    [BlockTypes.BlockMeeting]: <Meeting onCancel={onCancel} />,
  }

  return types[option] || null
}

const BlockType: React.FC<IBlockTypeButton> = ({
  option,
  onCancel,
  editing = false,
}) => {
  const { edit } = useSelector(({ blocks }: IMainState) => blocks)
  const containerRef = useRef(null)

  useEffect(() => {
    const timeout = setTimeout(() => {
      scrollToRef(containerRef)
    }, 500)
    return () => clearTimeout(timeout)
  }, [edit])
  return (
    <div
      ref={containerRef}
      className={`${styles.dashedContainer} fluid d-flex`}
    >
      <BlockTypeSelected {...{ option, onCancel, editing, containerRef }} />
    </div>
  )
}

export default BlockType
